import { Outlet, createFileRoute, useMatches } from '@tanstack/react-router';
import A2UIPreviewWorkbenchPage from '@/a2ui/preview/A2UIPreviewWorkbenchPage';
import { loadTypedA2UIRouteData } from '@/a2ui/router/loadA2UIRouteDataClient';

export const Route = createFileRoute('/_workbench/a2ui-preview')({
  loader: () => loadTypedA2UIRouteData('/a2ui-preview', 'preview'),
  component: () => {
    const isNestedPreview = useMatches({ select: (matches) => matches.at(-1)?.routeId !== Route.id });
    const data = Route.useLoaderData();
    // /a2ui-preview owns the default sample, while imported previews are nested under the same URL prefix; the parent must yield so POST-imported payloads replace the sample immediately.
    if (isNestedPreview) return <Outlet />;
    return <A2UIPreviewWorkbenchPage initialRaw={data.initialRaw} monacoSsrHtml={data.monacoSsrHtml} copy={data.copy} documentKey={data.documentKey} />;
  },
});
